/**
 * Handler for the redirect_to_pdp_images AI function.
 *
 * Navigates the user to /dashboard/pdp-images with the correct importType
 * and passes any chat-attached images via localStorage so they are
 * auto-loaded in the PDP images editor (AiRender3d.vue).
 */
const IMPORT_TYPE_LABELS = {
  '3d-image-edit': 'Image Editor',
  '3d-renders': '3D Render Studio',
  'photoshoot': 'Photo Studio',
};

export async function handleRedirectToPdpImages($message, { commit, dispatch } = {}) {
  let importType = '3d-image-edit';

  try {
    const args = typeof $message.function_call.arguments === 'string'
      ? JSON.parse($message.function_call.arguments)
      : $message.function_call.arguments || {};

    if (args.import_type) {
      importType = args.import_type;
    }
  } catch (e) {
    // Fall back to default import type
  }

  // Show a redirect message in the chat so the user knows what's happening
  if (commit) {
    const label = IMPORT_TYPE_LABELS[importType] || 'Image Editor';
    await dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: `Redirecting you to the <b>${label}</b>...`,
    });
  }

  // Pass any image attachments to the PDP images editor via localStorage.
  // AiRender3d.vue reads from 'ai-3d-renders' on mount and pre-loads them.
  const savedAttachments = $message.savedAttachments || [];
  const images = savedAttachments
    .filter(att => att.type === 'url' && att.payload)
    .map(att => {
      const url = att.payload;
      const name = att.name || url.split('/').pop()?.split('?')[0] || 'image';
      return {
        name,
        path: url,
        type: 'image',
        full_url: url,
        thumbnail: url,
      };
    });

  if (images.length > 0) {
    localStorage.setItem('ai-3d-renders', JSON.stringify(images));
  } else {
    localStorage.removeItem('ai-3d-renders');
  }

  // Return the redirect URL — sendMessage will navigate after saving state
  return { redirectUrl: '/dashboard/pdp-images?importType=' + importType };
};

export async function handleRedirectToSellSheet($message, { commit, dispatch } = {}) {
  try {
      await dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: `Redirecting you to the Sell Sheet page...`,
      });

      return { redirectUrl: '/dashboard/sell-sheet-v2' };
    } catch (error) {
      await dispatch('addAndSaveMessage', {
        role: 'assistant',
        content: `Sorry, there was an error opening the Sell Sheet page.`,
      });
    }
};
